
import React, { Component, createRef } from 'react';
import { connect } from "react-redux";
import * as actions from "../../actions";
import 'react-phone-input-2/lib/style.css'
import 'antd/dist/antd.css';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// import ReCAPTCHA from "react-google-recaptcha";
import { getBookingObject } from '../../util/getBookingInfo';
import BookingConfirmation from '../form-section/BookingConfirmation';
import TransparentOverlay from '../form-section/TransparentOverlay';
import { formSubmissionErrorStyle, buttonStyle, stepStyle } from './styles';


import {
  Form,
  Icon,
  Row,
  Col,
  Button,
  Typography,
} from 'antd';
import SignUpForm1 from './SignUpForm1';
import SignUpForm2 from './SignUpForm2';
import { isEmpty } from 'lodash';

const { Title } = Typography;

const errorDivRef = React.createRef();

// const API_KEY = process.env.REACT_APP_SITE_KEY;

class SignUp extends React.Component {
  state = {
    isFormSubmissionError: false,
    currentStep: 1,
    showCustomBrokerInput: false,
    showOverlay:false,
    bookingId:'',
    form1:{
      mode:'sea',
      legal_status:'partnership',
      business_type: 'wholesaler',
      legal_status_other:'',
      business_type_other:'',
      place_registration:'',
      year_established:'',
      no_of_employees:'',
      nature_of_business:'',
      parent_company:'',
      no_of_shipments:'10'
    },
    form2:{
      credit_amount_requested:  '',
      affiliates_credit : '',
      under_name : '',
      authorized_persons:[{}],
      bank_name: '',
      bank_contact_name:'',
      street: '',
      address: '',
      city: '',
      state:  '',
      postal: '',
      country: '',
      phone: '',
      email:'',
      references: [{}],
      privacy_policy:''
    },
    references: [{}],
    authorized_persons: [{}]
  };


  handleNextSubmit = e => {
    e.preventDefault();
    const {final_search_form, jwt_token,booking_customer_form, queryParams, agentInformation, transactionType} = this.props
    // console.log("agent Info: ",agentInformation)
    let bookingDatacharges = getBookingObject(final_search_form, queryParams, agentInformation, transactionType)
    // console.log("booking_customer_form: ",booking_customer_form,"bookingDatacharges: ",bookingDatacharges)
    if (this.state.currentStep === 1) {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState(prevState => ({
                  currentStep: prevState.currentStep + 1,
                }));
                this.setState({ isFormSubmissionError: false, form1: values });
              }else{
                this.setState({ isFormSubmissionError: true });
                if (errorDivRef.current) {
                  errorDivRef.current.scrollIntoView({ behavior: "smooth" });
                }
              }
            })
      } else if (this.state.currentStep === 2) {
        // Handle form submission for step 2
        this.props.form.validateFields(async (err, values) => {
            // console.log('----------Received values of form2: ', values,"references: ",this.state.references,
            //   "authorized_persons: ",this.state.authorized_persons
            // );
            const isEmptyObject = obj => Object.keys(obj).length === 0;

            const isArrayEmptyOrContainingOnlyEmptyObjects = arr => {
              return arr.length === 0 || arr.every(isEmptyObject);
            };
            if(this.state.references && this.state.references.length>0 && !isEmpty(this.state.references)){
              values.reference_company = this.state.references
            }
            if(isArrayEmptyOrContainingOnlyEmptyObjects(this.state.authorized_persons)){
              values.authorized_persons = []
            }else{
              values.authorized_persons = this.state.authorized_persons
            }
            if (!err) {
                  // Handle form submission logic here
                  this.setState({showOverlay:true})
                  try {
                    const res = await this.props.Create_New_Signup_Request(jwt_token,this.state.form1,values, booking_customer_form, bookingDatacharges)
                    this.setState({showOverlay:false})

                    if(res[0] && res?.[1] && res[1]!==''){
                      this.setState({bookingId: res[1]})
                      this.setState(prevState => ({
                        currentStep: prevState.currentStep + 1,
                      }));
                    }else{
                      this.props.updateErrorAndLoading('Error ! Please Contact Prime Freight', undefined)
                    }
                  }catch (error) {
                    console.error("Error:", error);
                    this.setState({showOverlay:false})
                  }
                 
              
                this.setState({ isFormSubmissionError: false, form2:values });

              }else{
                this.setState({ isFormSubmissionError: true });
                if (errorDivRef.current) {
                  errorDivRef.current.scrollIntoView({ behavior: "smooth" });
                }
              }
            })
      } else{
        console.log("step 3");
      }
  };

  handlePrevious = () => {
    const { currentStep } = this.state;
    // Go back to the previous step if currentStep is greater than 1
    if (currentStep > 1) {
      this.setState({ currentStep: currentStep - 1 });
    }
  };

  handleGoBack = () => {
    //make it false this.props.public_user_view_after_submit
    //handle back to application
    this.props.public_user_submit_button(false)
  };

  handleCustomBrokerChange = (e) => {
    const showInput = e.target.value === '1'; // '1' represents the value of the option "I have my own customs broker"
    this.setState({ showCustomBrokerInput: showInput });
  };


  handleReferenceChange = (index, key, value) => {
    const { references } = this.state;
    references[index][key] = value; // Update the value of the specified key in the reference object
    this.setState({ references });
  };

  handleAddReference = () => {
    const { references } = this.state;
    this.setState({
      references: [...references, {}],
    });
  };

  handleDeleteReference = index => {
    const { references } = this.state;
    references.splice(index, 1);
    this.setState({
      references: [...references],
    });
  };

  handleAuthorizedDetailChange = (index, key, value) => {
    const { authorized_persons } = this.state;
    authorized_persons[index][key] = value; // Update the value of the specified key in the reference object
    this.setState({ authorized_persons });
  };

  handleAddAuthorize = () => {
    const { authorized_persons } = this.state;
    this.setState({
      authorized_persons: [...authorized_persons, {}],
    });
  };

  handleDeleteAuthorize = index => {
    const { authorized_persons } = this.state;
    authorized_persons.splice(index, 1);
    this.setState({
      authorized_persons: [...authorized_persons],
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;

    const labelStyle ={
      fontWeight: '800',
      fontSize:'16px',
      width: '100%',
      textAlign:'left',
      whiteSpace: 'normal'
    }

    const stepStyle1 ={
      marginBottom:'1rem',
      width:'100%',
      borderBottom:'3px solid #2b2f89',
      fontSize:'10px',
      paddingTop:'1rem'
    }

    return (
      <div ref={errorDivRef} style={{padding: '2rem 0'}}>
      <Row type="flex" justify="center" //style={{border:"1px solid red"}}
      >
      
      <Col xs={20} sm={20} md={20} lg={18} xl={12}>
      {this.state.isFormSubmissionError ? (
       
       <div style={formSubmissionErrorStyle}>
       <Icon type="exclamation-circle" style={{ fontSize: '20px', color: '#790000' }} theme="outlined"/>
       &nbsp;<span>There was a problem with your submission. Please review the fields below.</span>
       </div>
     ) : ''}
     
      <Form //{...formItemLayout} 
      onSubmit={this.handleSubmit}  className = "booking-form" //style={bookingForm}
      >
         <div>
      {this.state.currentStep === 3 ? (
        <Title level={2} style={{ textAlign: 'center' }}>Thank you for Signing Up!</Title>
      ) : (
        <Title level={2}>Sign Up</Title>
      )}
      {/* Other content */}
    </div>
      {/* Section 1 */}
      {this.state.currentStep === 1 && (
        <div>
          <div style={{paddingBottom:'1rem'}}>
            <p style={stepStyle}>Step {this.state.currentStep} of 2</p>
          </div>
          <SignUpForm1 {...{ form: this.props.form }} initialFormData={this.state.form1}/>
          <div>
            <Form.Item>
                <Button type="default" htmlType="submit" style={buttonStyle} onClick={this.handleNextSubmit}>
                Continue
                </Button>
            </Form.Item>
          </div>
        </div>
      )}
        {/* Section 2 */}
        {this.state.currentStep === 2 && (
         <div>
            <p style={stepStyle1}>Step {this.state.currentStep} of 2</p>
            <SignUpForm2 {...{ form: this.props.form }} initialFormData={this.state.form2}
               references={this.state.references}
               handleReferenceChange={this.handleReferenceChange}
               handleAddReference={this.handleAddReference}
               handleDeleteReference={this.handleDeleteReference}
               authorized_persons={this.state.authorized_persons}
               handleAuthorizedDetailChange = {this.handleAuthorizedDetailChange}
               handleAddAuthorize ={this.handleAddAuthorize}
               handleDeleteAuthorize = {this.handleDeleteAuthorize}
            />
             {/* <Row>
                 <Form.Item
                label={<span style={labelStyle}>CAPTCHA</span>}
                colon={false}
              >
               {getFieldDecorator("captcha", {
                        rules: [
                          {
                            required: true,
                            message: 'required',
                          },
                        ],
                      })(
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={API_KEY}
                  //onChange={this.handleRecaptchaChange}
                  onChange={this.handleChange}
                />
                      )}
              </Form.Item>
            </Row> */}
            <div style={{borderBottom: '1px solid #e8e8e8',paddingBottom:'1rem', marginBottom:"1rem"}}></div>
            <Form.Item>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Button type="default" style={buttonStyle} onClick={this.handlePrevious}>
                  Previous
                </Button>
                <Button type="default" htmlType="submit" style={buttonStyle} onClick={this.handleNextSubmit}>
                  Submit
                </Button>
              </div>
              {this.state.showOverlay && 
              <TransparentOverlay message="Please wait..." />
            }
            
            </Form.Item>
         </div>
        )}

        {/* Section 3 */}
        {this.state.currentStep === 3 && (
         <div>
          <BookingConfirmation bookingId = {this.state.bookingId} signupMsg = "Your sign-up request has been submitted for approval. You will receive an email notification once it is approved."/>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
              <Button type="default" style={buttonStyle} onClick={this.handleGoBack}>
                    Back Home
              </Button>
            </div>
         </div>
        )}
      </Form>
      </Col>
      </Row>
      </div>
    );
  } 
}

  const WrappedSignUp = Form.create({ name: 'signup' })(SignUp);

  SignUp.propTypes = {
    /**
     * array index (starts from zero) of selected pickup/delivery existing factory in the list of factories.
     * It also accepts `null`
     */
    final_search_form: PropTypes.object,
    jwt_token: PropTypes.object,
    booking_customer_form: PropTypes.object,
    queryParams: PropTypes.object,
    agentInformation: PropTypes.object

  };
  const mapStateToProps = (state) => {
    return {
      queryParams: state.route.queryParams,
      final_search_form:state.route.final_search_form,
      booking_customer_form:state.route.booking_customer_form,
      jwt_token:state.route.JWT_TOKEN.JWT_TOKEN,
      agentInformation: state.form.AgentInformation,
      transactionType: state.code_config.transactionType,
    };
  };
  
  export default withRouter(connect(mapStateToProps, actions)(WrappedSignUp));